import { Options } from '@angular-slider/ngx-slider';
import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { BorgService } from 'src/app/services/borg.service';
import { UserCardioService } from 'src/app/services/user-cardio.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fit-edit-entry',
  templateUrl: './fit-edit-entry.component.html',
  styleUrls: ['./fit-edit-entry.component.scss']
})
export class FitEditEntryComponent {
  isLoading = false;
  bsDate = new Date();
  maxDate = new Date();
  userData: any;
  submitted = false;
  exercises: any;
  entryId:any;
  entryDate = new Date();
  userCardioWorkout:any;
    durations = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95,
    100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150,
  ];
  maxDuration = 60;
  topDuration = this.durations[this.durations.length - 1];
  intensity: number = 5;
  options: Options = {
    floor: 0,
    ceil: 10,
    hideLimitLabels: true,
    hidePointerLabels: true,
    showTicks: true,
    getTickColor: (value: number): string => {
      if (value == 1) {
        return '#1D8670';
      }
      if (value == 2) {
        return '#608F62';
      }
      if (value == 3) {
        return '#879359';
      }
      if (value == 4) {
        return '#B39950';
      }
      if (value == 5) {
        return '#DB9E47';
      }
      if (value == 6) {
        return '#EF9742';
      }
      if (value == 7) {
        return '#ED853F';
      }
      if (value == 8) {
        return '#EA723D';
      }
      if (value == 9) {
        return '#E8603B';
      }
      if (value == 10) {
        return '#E54B38';
      }
      return '#cccccc';
    },
  };

  @ViewChild('entryForm', { static: false }) entryForm?: NgForm;
  constructor(
    private userCardioService: UserCardioService,
    private router: Router,
    private userService: UserService,
    private route:ActivatedRoute,
    public borgService:BorgService
  ) {}

  ngOnInit(): void {
    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
      }
    });



    this.route.params.subscribe((params) => {
      this.entryId = params.id;
      this.isLoading = true;
      forkJoin({
        userCardioWorkout: this.userCardioService.fetch(this.entryId),
       exercises: this.userCardioService.fetchExercises()
      }).subscribe(
        (responseData) => {
          this.exercises = responseData.exercises;
          this.isLoading = false;
          this.userCardioWorkout = responseData.userCardioWorkout;
          this.bsDate = moment(this.userCardioWorkout.workout_date).toDate();
          this.intensity = this.userCardioWorkout.intensity;
        },
        (error) => {
         // this.errors.push(error.message);
        }
      );
    });
  }

  onSubmitForm() {
    this.userCardioService
      .update(
        this.entryId,
        this.entryForm?.value.minutes.minutes,
        moment(this.entryForm?.value.date).format('YYYY-MM-DD'),
        +this.entryForm?.value.exercise.exercise,
        this.intensity
      )
      .subscribe((responseData) => {
        window.scroll(0, 0);
        this.submitted = true;
        /*
        // refresh it
        Swal.fire({
          icon: 'success',
          title: 'Workout Added',
          text: 'Your workout was added',
          showConfirmButton: false,
          timer: 1000,
          timerProgressBar: true,
        });
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['/activity', 'fit', 'level', this.userData.fit_level]));*/
      });
  }

  onSetDuration(duration: number) {
    if (duration == this.maxDuration) {
      this.maxDuration += 30;
    }
  }


  onDeleteEntry() {
    Swal.fire({
      title: "Are you sure?",
      text:  "You won't be able to undo this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText:'Cancel',
      confirmButtonText:'Yes, delete it',
    }).then((result) => {
      if (result.value) {
        this.userCardioService.delete(this.entryId).subscribe(
          (responseData) => {
            Swal.fire("Your entry has been deleted", "success");
            // redirect
            this.router.navigateByUrl('/nothing', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/activity', 'fit', 'all-entries']);
          })


          },
          (error) => {
            this.isLoading = false;
            Swal.fire('Error', 'An unknown error has occured, please contact us', 'error');
          }
        );
      }
    });
  }
}
